import React from 'react';

function ThPermission (props) {
    return (
        <th {...props} hidden={props.hidden}>{props.children}</th>
    )
}

export default ThPermission;
